__webpack_require__.p = "/digilipik/";